import React from 'react';
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from '@mui/material';
import { Field } from 'redux-form';
import {
  renderTextArea,
} from 'components/form/field/redux-field';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { cpStyle } from '../../index.styles';
import { IFields } from '../../table/types';
import { VoicemailDynamicFieldsEnum } from '../../constants';

interface ISubFormProps {
  formTitle: string;
  fieldsInfo: IFields[];
  setFieldValue: (field: string, value: any) => void;
}

export const VoicemailFaxInfo: React.FC<ISubFormProps> = (props:ISubFormProps): JSX.Element => {
  const useStyles = makeStyles(cpStyle);
  const classes = useStyles();
  const MAX_LENGTH_INPUT = '100';

  const {
    formTitle,
    fieldsInfo,
    setFieldValue,
  } = props;

  React.useEffect(() => {
    const tempLoopFields = Object.values(VoicemailDynamicFieldsEnum) as string[];
    if (fieldsInfo.length) {
      for (const fieldInfo of fieldsInfo) {
        if (
          fieldInfo.fieldName &&
          tempLoopFields.includes(fieldInfo.fieldName) &&
          fieldInfo.value !== ''
        ) {
          setFieldValue(fieldInfo.fieldName, fieldInfo.value);
        }
      }
    }
  }, [fieldsInfo]);

  return (
    <Grid item xs={12}>
      <Accordion className={classes.accordionheader}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={classes.expandIconColor} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>
          <Tooltip title={formTitle} placement="right-end">
            <span className={classes.accordionTitle}>{`${formTitle}`}</span>
          </Tooltip>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.AccordionDetailsForm}>
        <Grid container spacing={3} className={classes.rowMarginTop}>
          <Grid item xs={12}>
          <Field
            name="voicemail_fax_info"
            label=""
            component={renderTextArea}
            placeholder="Insert instructions"
            rowsNumber={3}
            validate={[]}
            width="100%"
            cpInputProperties={{
              maxLength: MAX_LENGTH_INPUT,
            }}
          />
          </Grid>
        </Grid>
      </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
